<template>
  <section role="region" class="full-channel-section">
    <div class="wrapper">
      <TheSecondHead titleText="MeLembre é full channel" subtitleText="Está onde o cliente precisa, quando ele precisa."
        chipColor="white" chipText="Canais de comunicação" />
      <div class="channels">
        <div class="mobile-selector">
          <v-select v-model="selectedChannel" :items="channelsNames" base-color="#3303FF" hide-selected hide-details
            variant="outlined" ref="channelSelect" class="channels-select" transition="slide-y-transition">
            <template #prepend-inner>
              <img small :src="getItemIcon(selectedChannel)" :alt="`Ícone de ${selectedChannel}`" loading="lazy" />
            </template>

            <template #item="{ props }">
              <v-list-item class="ml-n1" :title="getItemTitle(props)" density="compact" :value="props.value"
                @click="toggle(props.value)">
                <template #prepend>
                  <img class="mr-1" :src="getItemIcon(props.value)" :alt="`Ícone de ${props.value}`" loading="lazy" />
                </template>
              </v-list-item>
            </template>
          </v-select>
        </div>
        <div class="desktop-selector">
          <v-list-item v-for="channel in channelsNames">
            <div class="list-item-title" :class="channel == selectedChannel ? 'active-item' : ''"
              @click="toggle(channel)">
              <img small :src="getItemIcon(channel)" :alt="`Ícone de ${channel}`" loading="lazy" />
              {{ channel }}
            </div>
            <div class="blue-line">
            </div>
          </v-list-item>
        </div>
        <div class="content">
          <div class="channel">
            <TheCard :thirdHeading="channels[selectedChannel].subtitle" :paragraphText="channels[selectedChannel].text">
              <template #out-of-box>
                <img v-if="showItems" :src="`/icons/business/${channels[selectedChannel].image}`"
                  :alt="`Ícone de ${selectedChannel}`" loading="lazy" />
              </template>
            </TheCard>

          </div>
          <div class="print">
            <img v-if="showItems" :src="`/images/business/${channels[selectedChannel].printScreen}`"
              :alt="`Tela de ${selectedChannel}`" loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { VSelect, VListItem } from 'vuetify/components';
import { useDisplay } from 'vuetify';

const showItems = ref<boolean>(true);
const channelSelect = ref<any>(null);
const selectedChannel = ref<string>("E-mail");
const channelsNames = ref<any>([
  'E-mail', 'SMS', 'PUSH', 'RCS', 'Voz', 'Whatsapp',
]);

const channels = ref<any>({
  'E-mail': {
    subtitle: "E-mail",
    text: "Templates de e-mails totalmente personalizáveis de acordo com sua marca",
    image: "mail.png",
    printScreen: "printEmail.png",
    icon: "cartinha"
  },
  'SMS': {
    subtitle: "SMS",
    text: "Estímulos diretamente no melhor contato do seu cliente",
    image: "sms.png",
    printScreen: "printSms.png",
    icon: "sms"
  },
  'PUSH': {
    subtitle: "Push",
    text: "Notificações altamente adaptáveis com nome dos usuários, emojis e muito mais",
    image: "push.png",
    printScreen: "printPush.png",
    icon: "push"
  },
  'RCS': {
    subtitle: "RCS",
    text: "Mensagens de texto personalizáveis com imagens e links",
    image: "rcs.png",
    printScreen: "printRcs.png",
    icon: "rcs"
  },
  'Voz': {
    subtitle: "Voz",
    text: "Canais de voz ativo e receptivo para os clientes que preferem ser contatados por ligação",
    image: "phone.png",
    printScreen: "printVoz.png",
    icon: "telefone"
  },
  'Whatsapp': {
    subtitle: "WhatsApp",
    text: "Mensagens personalizáveis contendo texto, imagens e anexo de documentos.",
    image: "whats.png",
    printScreen: "printWhats.png",
    icon: "whats"
  },
})

const getItemTitle = (item: any): string => {
  return item.title
}

const { width } = useDisplay()
const getItemIcon = (title: string | any): string => {
  if (title == selectedChannel.value && width.value > 833) {
    return `/icons/business/full-channel/${channels.value[title.toString()].icon}IconActive.png`;
  }
  return `/icons/business/full-channel/${channels.value[title.toString()].icon}Icon.png`;
}

const toggle = (item: any) => {
  showItems.value = false;
  selectedChannel.value = item;
  channelSelect.value.blur();
  setTimeout(() => {
    showItems.value = true;
  }, 250);
}

</script>

<style lang="scss">
@use "@/styles/variables" as *;

.full-channel-section {
  background-color: rgba(212, 213, 255, 0.50);
  max-width: none;

  .wrapper {
    padding: 40px 20px;

    .headline {
      text-align: center;
      width: 280px;
      margin: 0 auto;

      .title {
        margin: 16px 0px 21px;
        font-size: 40px;
        line-height: 110%;
      }
    }

    .channels {
      background: $greyLight;
      border-radius: 25px;
      padding: 15px 20px 0px;
      height: 673px;
      max-width: 600px;
      margin: 16px auto 0px;

      .mobile-selector {
        .channels-select {
          border-radius: 25px;
          color: $blue;
          font-size: 18px;
          font-weight: 600;
          line-height: normal;
        }
      }

      .desktop-selector {
        display: none;
      }

      .content {
        text-align: center;
        padding: 0px 20px;

        .default-card {
          background-color: transparent;
          box-shadow: none;

          img {
            margin: 29px 0px 12px;
            width: 45px;
          }

          p {
            margin: 7px 0px 23px;
          }
        }

        .print {
          display: flex;
          align-items: flex-end;
          justify-content: center;

          img {
            -webkit-animation-name: fade-in;
            animation-name: fade-in;
            -webkit-animation-duration: 1s;
            animation-duration: 1s;
          }
        }
      }
    }

    @media screen and (min-width: 834px) and (max-width: 959px) {
      padding: 81px 0px 55px;

      .channels {
        max-width: none;
        column-gap: 30px;
        padding: 0px;

        .content {
          column-gap: 47px;
          padding: 35px 70px 37px 92px;
          background-color: $greyLight;
          border-radius: 10px;
          width: 600px;
          height: 445px;
        }
      }
    }

    @media screen and (min-width: 960px) and (max-width: 1199px) {
      padding: 25px 0px 83px;
    }

    @media screen and (min-width: 834px) {
      .headline {
        width: unset;
      }

      .channels {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background: none;
        height: unset;
        padding-top: 16px;

        .mobile-selector {
          display: none;
        }

        .desktop-selector {
          display: unset;

          .v-list-item {
            padding: 0px;

            .v-list-item__content {
              display: flex;
              flex-direction: column;
              align-items: flex-start;

              .list-item-title {
                background-color: white;
                border-radius: 20px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 6px 10px 6px 8px;
                font-size: 18px;
                font-weight: 600;
                column-gap: 6px;
                cursor: pointer;
                color: $blue;

                img {
                  width: 26px;
                }

                &.active-item {
                  color: #939393;
                  cursor: unset;
                }
              }

              .blue-line {
                width: 1px;
                height: 32px;
                margin-left: 22px;
              }
            }

          }

          .v-list-item:not(:last-child) .v-list-item__content .blue-line {
            border-left: 2px dashed blue;

          }
        }

        .content {
          display: flex;
          flex-direction: row-reverse;
          justify-content: space-between;
          align-items: center;

          .default-card {
            background-color: $white;
            overflow: visible;
            width: 200px;
            border-radius: 10px;
            padding: 47px 26px 0px;

            img {
              position: absolute;
              top: 0px;
              margin: -22.5px 0px 0px;
            }

          }

          .print {
            background-color: #FBFBFB;
          }
        }
      }
    }

    @media screen and (min-width: 960px) {
      .channels {
        max-width: none;
        column-gap: 27.67px;

        .content {
          padding: 0px;
          column-gap: 26px;

          .print {
            width: 430px;
            height: 445px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .desktop-selector {
          margin-left: 4rem;
        }
      }
    }

    @media screen and (min-width: 1200px) {
      padding: 68px 0px;
    }
  }
}
</style>